<template>
  <div id="home" class="pl-6 pr-6 pt-0">
    <v-div fluid>
      <v-snackbar v-model="snackbar" :timeout="timeout">
        {{ error }}

        <template v-slot:action="{ attrs }">
          <v-btn color="red" text v-bind="attrs" @click="snackbar = false">
            Close
          </v-btn>
        </template>
      </v-snackbar>
      <main>
        <div class="container home-container">
          <div class="col-md-12" style="margin: 0 auto; text-align: center">
            <h1 class="newText1">GROW YOUR SALES WITH ENDWAIT</h1>
            <h1>
              <sub class="newText1">Introductory Offer Only</sub>
              <hr class="home-hr" />
            </h1>
          </div>
          <div class="row mt-4" style="margin: 0 auto">
            <div class="col-md-5" style="margin: 0 auto; text-align: center">
              <div class="col-md-12" style="">
                <div class="home-box">
                  <span class="lines1"
                    ><span class="extra01">UNLIMITED</span> Property Postings
                  </span>
                </div>
              </div>
              <div class="col-md-12" style="">
                <div class="home-box">
                  <span class="lines2"
                    ><span class="extra01">UNLIMITED</span> Contact details of
                    high quality, verified
                    <span class="extra01">SALES LEADS.</span></span
                  >
                </div>
              </div>
              <div class="col-md-12" style="">
                <div class="home-box">
                  <span class="lines3"
                    ><span class="extra01">CUSTOMERS</span> from
                    <span class="extra01">ALL OVER THE WORLD</span></span
                  >
                </div>
              </div>
            </div>
            <div
              class="col-md-2"
              style="
                display: flex;
                align-items: center;
                justify-content: center;
              "
            >
              <div class="hand-icon">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  xmlns:xlink="http://www.w3.org/1999/xlink"
                  version="1.1"
                  width="auto"
                  viewBox="0 0 256 256"
                  xml:space="preserve"
                >
                  <desc>Created with Fabric.js 1.7.22</desc>
                  <defs></defs>
                  <g transform="translate(128 128) scale(0.72 0.72)" style="">
                    <g
                      style="
                        stroke: none;
                        stroke-width: 0;
                        stroke-dasharray: none;
                        stroke-linecap: butt;
                        stroke-linejoin: miter;
                        stroke-miterlimit: 10;
                        fill: none;
                        fill-rule: nonzero;
                        opacity: 1;
                      "
                      transform="translate(-175.05 -175.05000000000004) scale(3.89 3.89)"
                    >
                      <path
                        d="M 89.689 16.621 c -0.198 -0.188 -0.461 -0.284 -0.739 -0.274 c -6.479 0.321 -13.518 1.398 -22.148 3.389 c -0.271 0.063 -0.504 0.235 -0.643 0.476 c -0.139 0.241 -0.17 0.529 -0.088 0.794 l 0.838 2.704 c -6.363 -2.413 -15.313 -3.802 -23.06 -3.497 c -2.84 0 -6.082 1.409 -9.045 3.5 H 23.089 l 0.839 -2.708 c 0.083 -0.266 0.05 -0.553 -0.088 -0.794 c -0.138 -0.241 -0.371 -0.414 -0.642 -0.476 c -8.63 -1.991 -15.668 -3.068 -22.148 -3.389 c -0.269 -0.012 -0.54 0.085 -0.739 0.274 C 0.112 16.81 0 17.072 0 17.346 v 34.342 c 0 0.553 0.448 1 1 1 h 12.378 c 0.438 0 0.826 -0.285 0.955 -0.704 l 0.472 -1.523 c 10.187 11.872 20.546 22.775 28.634 22.775 c 1.557 0 3.029 -0.411 4.401 -1.29 l 0.211 0.214 c 0.944 0.956 2.209 1.487 3.561 1.495 c 0.011 0 0.021 0 0.032 0 c 1.339 0 2.597 -0.515 3.546 -1.451 c 0.834 -0.825 1.299 -1.873 1.436 -2.956 c 0.93 0.771 2.061 1.18 3.206 1.18 c 1.281 -0.001 2.564 -0.484 3.547 -1.454 c 1.109 -1.096 1.58 -2.581 1.456 -4.025 c 0.446 0.11 0.897 0.185 1.35 0.185 c 1.283 0 2.538 -0.443 3.448 -1.342 c 0.956 -0.944 1.487 -2.209 1.495 -3.561 s -0.507 -2.622 -1.387 -3.507 c -0.368 -0.453 -0.748 -0.888 -1.121 -1.334 l 6.816 -4.149 l 0.23 0.742 c 0.13 0.419 0.517 0.704 0.955 0.704 H 89 c 0.553 0 1 -0.447 1 -1 V 17.346 C 90 17.072 89.888 16.81 89.689 16.621 z M 12.641 50.688 H 2 V 18.403 c 5.806 0.359 12.122 1.335 19.699 3.043 L 12.641 50.688 z M 68.227 62.368 c -1.139 1.126 -3.31 1.005 -4.556 -0.258 c -0.017 -0.017 -0.039 -0.023 -0.057 -0.038 c -0.067 -0.077 -0.118 -0.163 -0.191 -0.237 l -10.95 -11.086 c -0.39 -0.392 -1.021 -0.396 -1.415 -0.009 c -0.393 0.389 -0.396 1.021 -0.009 1.415 l 10.95 11.086 c 0.569 0.575 0.88 1.343 0.875 2.16 c -0.005 0.816 -0.325 1.58 -0.901 2.148 c -1.195 1.183 -3.128 1.168 -4.31 -0.026 l -2.425 -2.455 c -0.002 -0.002 -0.003 -0.004 -0.004 -0.005 l -10.95 -11.085 c -0.389 -0.391 -1.022 -0.396 -1.414 -0.009 c -0.393 0.389 -0.397 1.021 -0.009 1.415 L 53.81 66.47 c 1.182 1.195 1.17 3.129 -0.026 4.31 c -1.196 1.182 -3.13 1.168 -4.31 -0.026 l -13.38 -13.545 c -0.389 -0.392 -1.022 -0.398 -1.414 -0.008 c -0.393 0.388 -0.397 1.021 -0.009 1.414 l 11.711 11.855 c -7.435 3.974 -19.75 -9.239 -30.877 -22.268 l 6.965 -22.487 h 9.815 c -2.741 2.432 -5.001 5.336 -6.092 7.983 c -1.396 3.386 -0.487 5.29 0.521 6.291 c 0.026 0.026 0.054 0.051 0.083 0.074 c 3.843 3.047 7.628 3.815 13.523 -2.283 c 2.001 0.122 3.705 -0.225 5.184 -1.064 c 8.306 5.807 15.937 12.961 22.749 21.343 C 69.435 59.254 69.423 61.188 68.227 62.368 z M 67.318 53.842 c -6.406 -7.41 -13.527 -13.843 -21.216 -19.146 c -0.341 -0.236 -0.793 -0.236 -1.134 -0.001 c -1.322 0.907 -2.939 1.251 -4.944 1.055 c -0.311 -0.034 -0.614 0.084 -0.827 0.31 c -5.585 5.943 -8.344 4.656 -11.109 2.473 c -0.996 -1.039 -0.577 -2.784 -0.046 -4.073 c 2.224 -5.398 10.113 -12.246 15.846 -12.247 c 8.172 -0.313 17.649 1.276 23.786 3.967 l 7.152 23.091 L 67.318 53.842 z M 88 50.688 H 77.358 l -9.058 -29.242 c 7.577 -1.708 13.894 -2.684 19.699 -3.043 V 50.688 z"
                        style="
                          stroke: none;
                          stroke-width: 1;
                          stroke-dasharray: none;
                          stroke-linecap: butt;
                          stroke-linejoin: miter;
                          stroke-miterlimit: 10;
                          fill: rgb(0, 0, 0);
                          fill-rule: nonzero;
                          opacity: 1;
                        "
                        transform=" matrix(1 0 0 1 0 0) "
                        stroke-linecap="round"
                      />
                    </g>
                  </g>
                </svg>
              </div>
            </div>
            <div class="col-md-5" style="margin: 0 auto; text-align: center">
              <div class="col-md-12" style="">
                <div class="home-box">
                  <span class="lines4"
                    ><span class="extra01">ZERO</span> Transaction Fee</span
                  >
                </div>
              </div>
              <div class="col-md-12" style="">
                <div class="home-box">
                  <span class="lines5"
                    >No <span class="extra01">POSTING</span> or
                    <span class="extra01">HIDDEN</span> Fees.</span
                  >
                </div>
              </div>
              <div class="col-md-12" style="">
                <div class="home-box">
                  <span class=""
                    >Absolutely <span class="extra01">FREE</span></span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="row" style="margin: 0 auto">
            <div class="col-md-12 text-center mt-4 mb-4">
              <v-btn
                @click.prevent="modal = true"
                :loading="loading.personalInfo"
                type="submit"
                class="deep-orange white--text"
                depressed
                >Post Your Property
              </v-btn>
            </div>
          </div>
        </div>
      </main>

      <upload-video-modal
        :open-dialog="dialog"
        v-on:closeDialog="dialog = false"
        :video-limit="videoLimit"
      />
    </v-div>
  </div>
</template>

<script>
import moment from "moment";
import UploadVideoModal from "@/components/UploadVideoModal";
import VideoService from "@/services/VideoService";

export default {
  name: "Home",
  data: () => ({
    loading: false,
    dialog: false,
    loaded: false,
    errored: false,
    isMobile: false,
    videoLimit: false,
    snackbar: false,
    error: "",
    timeout: 3000,
  }),
  mounted() {
    this.checkMobile();
  },
  created() {
    console.log("created");
  },
  methods: {
    checkMobile() {
      if (screen.width <= 760) {
        this.isMobile = true;
      } else {
        this.isMobile = false;
      }
    },
    async modal() {
      await VideoService.getVideoCount()
        .then((res) => {
          console.log(111);
          console.log(res);
          console.log(222);
          console.log("response ===>", res);
          if (res.data.statusCode == 200) {
            this.videoLimit = true;
          } else {
            this.videoLimit = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
      this.dialog = true;
    },
    dateFormatter(date) {
      return moment(date).fromNow();
    },
  },
  components: {
    UploadVideoModal,
  },
};
</script>

<style lang="scss">
.card {
  background: white !important;
}

label.v-label.theme--light {
  font-size: 14px;
}

span.extra01 {
  font-size: 1em;
}

.ls-style {
  list-style-type: none;
  font-size: 1em;
  font-weight: 500;
}

.home-hr {
  width: 30%;
  margin: 0 auto;
  margin-top: 2%;
  border-color: #e6e6e6;
}

.newText1 {
  color: #1e1e1e;
  text-shadow: -2px 2px 4px rgb(0 0 0 / 50%), 2px -2px 0 rgb(255 255 255 / 90%);
}

.home-box {
  background: white;
  padding: 2%;
  width: 100%;
  box-shadow: 3px 2px 2px #d2d2d2;
  margin: 0 auto;
  padding-top: 7%;
  padding-bottom: 7%;
  min-height: 130px;
  font-size: 1.2em;
  font-weight: 500;
  color: #383838;
  /* display: inherit !important; */
}

.home-box2 {
  background: white;
  min-height: 130px;
  padding: 2%;
  float: right;
  width: 100%;
  box-shadow: 3px 2px 2px #d2d2d2;
  margin: 0 auto;
  padding-top: 7%;
  padding-bottom: 7%;
  display: inherit !important;
  text-align: left;
}

.hpt-2 {
  padding-top: 0px;
}

.home-box:hover {
  box-shadow: 4px 4px 4px #b5b5b5;
}

.home-box2:hover {
  box-shadow: 4px 4px 4px #b5b5b5;
}

.home-box {
  --transition-duration: 500ms;
  --transition-easing: ease-out;

  width: var(--size);
  height: var(--size);
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;

  text-decoration: none;
  color: var(--foreground-color);
  background-color: rgb(246 156 28); //rgba(white, 0.4);
  backdrop-filter: blur(2px);
  border-radius: 0.5rem;
  box-shadow: 0px calc(var(--size) / 6) calc(var(--size) / 3) rgba(black, 0.1);

  transition: transform var(--transition-duration) var(--transition-easing);

  overflow: hidden;

  &::before {
    content: "";
    background: rgba(white, 0.4);
    width: 60%;
    height: 100%;
    top: 0%;
    left: -125%;

    transform: skew(45deg);

    position: absolute;
    padding: 0;
    transition: left var(--transition-duration) var(--transition-easing);
  }

  &:hover {
    &::before {
      left: 150%;
    }
  }
}

.v-input__control {
  /* display: flex; */
  /* flex-direction: column; */
  /* height: auto; */
  /* flex-grow: 1; */
  /* flex-wrap: wrap; */
  min-width: 0;
  width: 95%;
}

// .v-dialog:not(.v-dialog--fullscreen) {
//   // max-height: none !important;
// }

nes1 {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
}

@media (min-width: 320px) {
  /* smartphones, iPhone, portrait 480x320 phones */
  .home-container {
    width: 100%;
  }
  @media (min-width: 481px) {
    /* portrait e-readers (Nook/Kindle), smaller tablets @ 600 or @ 640 wide. */
    .home-container {
      width: 100%;
    }
  }
  @media (min-width: 641px) {
    /* portrait tablets, portrait iPad, landscape e-readers, landscape 800x480 or 854x480 phones */
    .home-container {
      width: 100%;
    }
  }

  @media (min-width: 961px) {
    /* tablet, landscape iPad, lo-res laptops ands desktops */
    .home-container {
      width: 100%;
    }
  }
}

button.d-sm-none.v-btn.v-btn--icon.v-btn--round.theme--light.v-size--default {
  display: none;
}
</style>
